import { defineComponent as _defineComponent } from 'vue'
import { onBeforeUnmount, watch } from "vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Modal',
  props: {
    isOpen: { type: Boolean, default: false },
    showClose: { type: Boolean, default: true },
    showContainer: { type: Boolean, default: true },
    classes: { type: [String, Array], default: "" },
    transitionName: { type: String, default: "fade" },
    maxWidth: { type: Boolean, default: false },
  },
  emits: ["close", "submit"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const emit = __emit;
  const props = __props;

  watch(
    () => props.isOpen,
    () => {
      if (props.isOpen) {
        document.body.classList.add("no-scroll");
      } else {
        document.body.classList.remove("no-scroll");
      }
    },
    { immediate: true }
  );

  function close() {
    emit("close");
  }

  const keyPress = (event: KeyboardEvent) => {
    if (event && event.code === "Escape") {
      close();
    }
  };

  document.addEventListener("keydown", keyPress);

  onBeforeUnmount(() => {
    document.removeEventListener("keydown", keyPress);
    document.body.classList.remove("no-scroll");
  });

const __returned__ = { emit, props, close, keyPress, onBeforeUnmount, watch }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})